import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "row ps-2 pe-2" };
const _hoisted_2 = { class: "col-12 col-lg-8" };
const _hoisted_3 = { class: "position-relative sv-3" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-2 d-none d-sm-block" };
const _hoisted_6 = { class: "product-image h-100" };
const _hoisted_7 = { class: "col-7 col-sm-6" };
const _hoisted_8 = { class: "d-flex align-items-start flex-column h-100" };
const _hoisted_9 = { class: "mb-auto pb-2" };
const _hoisted_10 = { class: "fw-bold" };
const _hoisted_11 = { class: "small mb-1" };
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
    key: 0,
    class: "mb-4"
};
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("div", { class: "seperator" }, null, -1);
const _hoisted_15 = [
    _hoisted_14
];
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-4" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "seperator" })
], -1);
const _hoisted_17 = { class: "p-2 text-end align-self-end" };
const _hoisted_18 = { class: "font-weight-bolder text-primary m-0" };
const _hoisted_19 = { class: "small" };
const _hoisted_20 = { class: "col-5 col-sm-4 text-end align-self-end" };
const _hoisted_21 = {
    key: 0,
    class: "row"
};
const _hoisted_22 = { class: "col-10" };
const _hoisted_23 = { class: "row" };
const _hoisted_24 = { class: "col" };
const _hoisted_25 = { class: "row" };
const _hoisted_26 = { class: "col-2 ps-0" };
const _hoisted_27 = {
    key: 0,
    class: "separator separator-dashed"
};
const _hoisted_28 = { class: "col-12 col-lg-4" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("div", { class: "d-block d-lg-none mt-3 mb-3" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-border-2 separator-solid separator-primary" })
], -1);
const _hoisted_30 = { class: "sticky-top-20 sv-2" };
const _hoisted_31 = { class: "row" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("div", { class: "col-4 d-flex" }, " Nummer ", -1);
const _hoisted_33 = { class: "col-8 text-end" };
const _hoisted_34 = {
    key: 0,
    class: "spinner"
};
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("div", { class: "bounce1" }, null, -1);
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("div", { class: "bounce2" }, null, -1);
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("div", { class: "bounce3" }, null, -1);
const _hoisted_38 = [
    _hoisted_35,
    _hoisted_36,
    _hoisted_37
];
const _hoisted_39 = { key: 1 };
const _hoisted_40 = { class: "row" };
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("div", { class: "col-4 d-flex" }, " Bestellliste ", -1);
const _hoisted_42 = { class: "col-8 text-end" };
const _hoisted_43 = { class: "row" };
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("div", { class: "col-4 d-flex" }, " Konto ", -1);
const _hoisted_45 = { class: "col-8 text-end" };
const _hoisted_46 = {
    key: 0,
    class: "row"
};
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("div", { class: "col-4 d-flex" }, " Adresse ", -1);
const _hoisted_48 = ["innerHTML"];
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-dashed" }, null, -1);
const _hoisted_50 = {
    key: 0,
    class: "row"
};
const _hoisted_51 = /*#__PURE__*/ _createElementVNode("div", { class: "col-4 d-flex" }, " Versandart ", -1);
const _hoisted_52 = { class: "col-8 text-end" };
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-dashed" }, null, -1);
const _hoisted_54 = { class: "row" };
const _hoisted_55 = { class: "col-3 d-flex" };
const _hoisted_56 = /*#__PURE__*/ _createTextVNode("Bemerkung ");
const _hoisted_57 = {
    class: "col-9 text-end",
    style: { "white-space": "pre" }
};
const _hoisted_58 = /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-dashed" }, null, -1);
const _hoisted_59 = { class: "row" };
const _hoisted_60 = { class: "col-1" };
const _hoisted_61 = ["onClick"];
const _hoisted_62 = { class: "col-8" };
const _hoisted_63 = { class: "text-muted" };
const _hoisted_64 = {
    key: 0,
    class: "text-muted"
};
const _hoisted_65 = /*#__PURE__*/ _createElementVNode("u", null, "Bemerkung:", -1);
const _hoisted_66 = { class: "col-3 text-end" };
const _hoisted_67 = /*#__PURE__*/ _createTextVNode(" Stk");
const _hoisted_68 = {
    key: 0,
    class: "row"
};
const _hoisted_69 = /*#__PURE__*/ _createElementVNode("div", { class: "col-1 ps-1" }, null, -1);
const _hoisted_70 = /*#__PURE__*/ _createElementVNode("div", { class: "col-11 ps-1" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-dotted" })
], -1);
const _hoisted_71 = [
    _hoisted_69,
    _hoisted_70
];
const _hoisted_72 = /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-dashed" }, null, -1);
const _hoisted_73 = { class: "row" };
const _hoisted_74 = /*#__PURE__*/ _createElementVNode("div", { class: "col-1 ps-1" }, null, -1);
const _hoisted_75 = /*#__PURE__*/ _createElementVNode("div", { class: "col-6 ps-1" }, " Gesamt-Menge: ", -1);
const _hoisted_76 = { class: "col-5 text-end" };
const _hoisted_77 = /*#__PURE__*/ _createTextVNode(" Stk");
const _hoisted_78 = { class: "row" };
const _hoisted_79 = /*#__PURE__*/ _createElementVNode("div", { class: "col-1 ps-1" }, null, -1);
const _hoisted_80 = /*#__PURE__*/ _createElementVNode("div", { class: "col-6 ps-1" }, " Nettobetrag: ", -1);
const _hoisted_81 = { class: "col-5 text-end" };
const _hoisted_82 = /*#__PURE__*/ _createTextVNode(" EUR");
const _hoisted_83 = /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-dashed" }, null, -1);
const _hoisted_84 = {
    class: "row",
    style: { "font-weight": "bold" }
};
const _hoisted_85 = { class: "col" };
const _hoisted_86 = { class: "col ps-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_portal = _resolveComponent("portal");
    const _component_g_breadcrumb = _resolveComponent("g-breadcrumb");
    const _component_g_image_viewer = _resolveComponent("g-image-viewer");
    const _component_g_number_field = _resolveComponent("g-number-field");
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_loader = _resolveComponent("g-loader");
    const _component_g_select_field = _resolveComponent("g-select-field");
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_content_page = _resolveComponent("g-content-page");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_portal, {
            to: "command-bar",
            order: 900
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", null, [
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.OnRefresh($event)))
                    }, "Aktualisieren")
                ])
            ]),
            _: 1
        }),
        _createVNode(_component_g_content_page, null, {
            title: _withCtx(() => [
                _createVNode(_component_g_breadcrumb, { "show-home": true })
            ]),
            content: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: product.itemNumber
                                }, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createVNode(_component_g_image_viewer, {
                                                    images: product.images,
                                                    "show-thumbnails": false,
                                                    "image-spacing": "5px"
                                                }, null, 8, ["images"])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("div", _hoisted_9, [
                                                    _createElementVNode("div", _hoisted_10, _toDisplayString(product.title), 1),
                                                    _createElementVNode("div", _hoisted_11, "Artikelnummer: " + _toDisplayString(product.itemNumber), 1)
                                                ]),
                                                (product?.texte?.list1?.items && product.texte.list1.items.length > 0)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.texte.list1.items, (text) => {
                                                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                                _createElementVNode("div", {
                                                                    class: "product-text",
                                                                    innerHTML: text.text
                                                                }, null, 8, _hoisted_12),
                                                                (text.seperator)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                                                                    : _createCommentVNode("", true)
                                                            ], 64));
                                                        }), 256)),
                                                        _hoisted_16
                                                    ], 64))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("h5", _hoisted_18, _toDisplayString(product.priceFormatted), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product?.priceNotes, (note) => {
                                                        return (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(note.text), 1));
                                                    }), 256))
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_20, [
                                            (_ctx.canOrder(product))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                    _createElementVNode("div", _hoisted_22, [
                                                        _createElementVNode("div", _hoisted_23, [
                                                            _createElementVNode("div", _hoisted_24, [
                                                                _createVNode(_component_g_number_field, {
                                                                    "data-object": product,
                                                                    "data-member": "__cart_quantity",
                                                                    "data-mode": "model",
                                                                    "show-label": false,
                                                                    "input-attr": { class: 'text-center' },
                                                                    label: _ctx.$t('client.Commerce.Products.Quantity'),
                                                                    "min-value": 0
                                                                }, null, 8, ["data-object", "label"])
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_25, [
                                                            _createVNode(_component_g_text_field, {
                                                                "field-class": "mb-0 pb-0",
                                                                "data-object": product,
                                                                "data-member": "__cart_comment",
                                                                "data-mode": "model",
                                                                placeholder: "Bemerkung"
                                                            }, null, 8, ["data-object"])
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_26, [
                                                        _createVNode(_component_g_button, {
                                                            class: "h-100",
                                                            "button-style": "btn-outline-primary",
                                                            text: "+",
                                                            onClick: _withModifiers(($event) => (_ctx.OnAddToCart(product)), ["stop", "prevent"])
                                                        }, null, 8, ["onClick"])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    (index != _ctx.products.length - 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 128)),
                            (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_g_loader, { key: 0 }))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createElementVNode("div", _hoisted_33, [
                                    (_ctx.isLoading)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_38))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                            _createElementVNode("b", null, _toDisplayString(_ctx.orderList.number), 1)
                                        ]))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                                _hoisted_41,
                                _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("b", null, _toDisplayString(_ctx.orderList.name), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                                _hoisted_44,
                                _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("b", null, _toDisplayString(_ctx.orderList.accountKonto), 1)
                                ])
                            ]),
                            (_ctx.orderList?.addresses?.delivery?.caption)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _hoisted_47,
                                    _createElementVNode("div", {
                                        class: "col-8 text-end",
                                        innerHTML: _ctx.orderList?.addresses?.delivery?.caption
                                    }, null, 8, _hoisted_48)
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.orderList?.schema?.shipping)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_49,
                                    (_ctx.orderList?.addresses?.delivery?.caption)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                            _hoisted_51,
                                            _createElementVNode("div", _hoisted_52, [
                                                _createVNode(_component_g_select_field, {
                                                    "data-mode": "model",
                                                    "is-standalone": true,
                                                    "data-object": _ctx.cartData,
                                                    "data-member": 'shipping.mode',
                                                    "search-enabled": true,
                                                    itemSource: _ctx.orderList?.schema?.shipping,
                                                    valueExpr: "name",
                                                    displayExpr: "caption"
                                                }, null, 8, ["data-object", "data-member", "itemSource"])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 64))
                                : _createCommentVNode("", true),
                            _hoisted_53,
                            _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                    _hoisted_56,
                                    _createElementVNode("div", {
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => (_ctx.OnCommentEdit && _ctx.OnCommentEdit(...args)), ["prevent"])),
                                        class: "text-muted ms-1 btn-image-link position-relative",
                                        style: { "height": "24px", "padding": "4px" }
                                    }, [
                                        _createVNode(_component_g_icon, {
                                            width: "16",
                                            height: "16",
                                            src: "/assets/icons/pen.svg",
                                            style: { "vertical-align": "unset", "display": "inline-block" }
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$utils.leftWithEllipsis(_ctx.orderList.comment ?? '--', 250)), 1)
                            ]),
                            _hoisted_58,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderList?.lines, (line, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("div", _hoisted_60, [
                                            _createElementVNode("a", {
                                                href: "#",
                                                onClick: _withModifiers(($event) => (_ctx.OnDeleteLine(line)), ["stop", "prevent"]),
                                                class: "btn btn-outline-danger btn-sm",
                                                style: { "padding": "4px", "line-height": "1", "border-width": "0px", "margin-top": "2px" }
                                            }, [
                                                _createVNode(_component_g_icon, {
                                                    width: "16",
                                                    height: "16",
                                                    src: "/assets/icons/trash.svg",
                                                    style: { "vertical-align": "unset", "display": "inline-block" }
                                                })
                                            ], 8, _hoisted_61)
                                        ]),
                                        _createElementVNode("div", _hoisted_62, [
                                            _createElementVNode("div", null, _toDisplayString(line.caption1) + " " + _toDisplayString(line.caption2), 1),
                                            _createElementVNode("div", _hoisted_63, _toDisplayString(line.itemNumber), 1),
                                            (line.comment)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                    _hoisted_65,
                                                    _createTextVNode(" " + _toDisplayString(line.comment), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_66, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("b", null, _toDisplayString(line.quantity), 1),
                                                _hoisted_67
                                            ])
                                        ])
                                    ]),
                                    (_ctx.orderList.lines.length - 1 != index)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, _hoisted_71))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 256)),
                            (_ctx.orderList?.lineQuantity > 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _hoisted_72,
                                    _createElementVNode("div", _hoisted_73, [
                                        _hoisted_74,
                                        _hoisted_75,
                                        _createElementVNode("div", _hoisted_76, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("b", null, _toDisplayString(_ctx.orderList.lineQuantity), 1),
                                                _hoisted_77
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_78, [
                                        _hoisted_79,
                                        _hoisted_80,
                                        _createElementVNode("div", _hoisted_81, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("b", null, _toDisplayString(_ctx.$utils.formatNumberWithDcp(_ctx.orderList.totalNetAmount, 2)), 1),
                                                _hoisted_82
                                            ])
                                        ])
                                    ]),
                                    _hoisted_83
                                ], 64))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_84, [
                                _createElementVNode("div", _hoisted_85, [
                                    _createElementVNode("button", {
                                        class: "btn btn-primary w-100",
                                        onClick: _cache[2] || (_cache[2] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => (_ctx.onBack && _ctx.onBack(...args)), ["stop", "prevent"]))
                                    }, "Zurück")
                                ]),
                                _createElementVNode("div", _hoisted_86, [
                                    _createVNode(_component_g_button, {
                                        text: "Absenden",
                                        onClick: _withModifiers(_ctx.OnListSend, ["stop", "prevent"])
                                    }, null, 8, ["onClick"])
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            _: 1
        })
    ], 64));
}
